@if(loading) {

<div class="mb-2 flex align-items-center justify-content-between">
    <div class="flex align-items-center">
        <i class="pi pi-file-edit text-500 mr-2 text-xl"></i>
        <span class=" font-medium text-900">Änderungen werden geladen ... bitte warten!</span>
    </div>
</div>
<div class="loading-container">
    <div class="loading-centered-element"><i class="pi pi-spin pi-spinner" style="font-size: 5rem"></i></div>
</div>
} @else {

    <div class="mb-2 flex align-items-center justify-content-between">
        <div class="flex align-items-center">
            <i class="pi pi-file-edit text-500 mr-2 text-xl"></i>
            <span class="text-xl font-medium text-900">Änderungen</span>
        </div>
    </div>
    <p-divider></p-divider>
    <div class="version">
        @for (change of changes; track changes) {
        <div class="grid">
            <div class="col-4">
                Version: {{ change.version }} vom {{ change.date}}
            </div>
            <div class="col-8">
                <ul class="list-disc  m-0">
                @for (info of change.infos; track info) {
                    <li>{{ info }} </li>
                }
            </ul>
            </div>
        </div>
        <p-divider></p-divider>
    }
    </div>
}